import { jsx as _jsx } from "react/jsx-runtime";
import { RouterProvider } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { router } from './router';
import { AuthProvider } from '@/providers/AuthProvider';
import { QueryProvider } from '@/providers/QueryProvider';
import { ToastProvider } from '@/components/ui/Toast';
export function App() {
    return (_jsx(HelmetProvider, { children: _jsx(QueryProvider, { children: _jsx(AuthProvider, { children: _jsx(ToastProvider, { children: _jsx(RouterProvider, { router: router }) }) }) }) }));
}
